<template>
  <b-dropdown
    size="xl"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
  >
    <template v-slot:button-content>
      <font-awesome-icon
        :icon="['fas', 'plus-circle']"
        class="text-primary"
        style="cursor: pointer;"
      />
      <span class="sr-only"> {{ $t('treatments.searchDropdown') }} </span>
    </template>

    <div class="p-2 mr-3">
      <input
        class="form-control"
        v-model="categorySearch"
        :placeholder="`Pesquisar ${
          mainCategoryId ? 'subcategorias' : 'categorias'
        }`"
      />
    </div>

    <b-list-group v-if="!mainCategoryId && options.length !== 0">
      <b-dropdown-text>
        <b-list-group-item
          style="padding: 6px; margin-bottom: 3px; border: none;"
          v-for="(option, i) in categoriesList"
          :key="i"
          :value="option._id"
          @click="handleCategoryClick(option)"
          :active="
            myAnswer.categories.findIndex((el) => el._id === option._id) >= 0
          "
        >
          {{ option.name }}
        </b-list-group-item>
      </b-dropdown-text>
      <b-dropdown-text class="pl-2">
        <p>
          {{ $t('treatments.registerCategory') }}
          <router-link
            :to="{
              name: 'Configurações',
              params: { settings: 'add-category' },
            }"
            class="text-primary"
          >
            {{ $t('treatments.here') }}
          </router-link>
        </p>
      </b-dropdown-text>
    </b-list-group>

    <b-list-group v-if="mainCategoryId && subCategories.length !== 0">
      <b-dropdown-text>
        <b-list-group-item
          style="padding: 6px; margin-bottom: 3px; border: none;"
          v-for="(subcategory, i) in subCategories"
          :key="i"
          :value="subcategory._id"
          @click="handleSubCategoryClick(subcategory)"
          :active="
            myAnswer.subCategories.findIndex(
              (el) => el._id === subcategory._id,
            ) >= 0
          "
        >
          {{ subcategory.name }}
        </b-list-group-item>
      </b-dropdown-text>
      <b-dropdown-text class="pl-2">
        <span>
          {{ $t('treatments.registerCategory') }}
          <router-link :to="`/settings`" class="preview">
            {{ $t('treatments.here') }}
          </router-link>
        </span>
      </b-dropdown-text>
    </b-list-group>
  </b-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../services/api';

export default {
  props: {
    idItem: { type: String },
    categories: { type: Array },
    categoryGroupId: { type: String },
    myAnswer: { type: Object },
    mainCategoryId: { type: String },
  },

  data: () => ({
    userAuth: null,
    categorySearch: '',
    actionCategories: [],
    subCategories: [],
    options: [],
    loading: false,
  }),

  computed: {
    ...mapState('treatments', ['answer', 'oneAnswer']),

    categoriesList() {
      return this.options.filter((option) => {
        return option.name
          .toLowerCase()
          .includes(this.categorySearch.toLowerCase());
      });
    },
  },

  methods: {
    async handleCategoryClick(option) {
      const categoryIndex = this.options.findIndex(
        (el) => el._id === option._id,
      );

      const category = this.options[categoryIndex];
      const foundIndex = this.myAnswer.categories.findIndex(
        (el) => el._id === option._id,
      );

      if (foundIndex >= 0) {
        this.myAnswer.categories.splice(foundIndex, 1);

        const response = await api.patch(
          `/answer-categories/${this.myAnswer._id}`,
          {
            operation: 'delete',
            categoryId: option._id,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.myAnswer.subCategories = response.data.subCategories;
      } else {
        this.myAnswer.categories.push(category);

        await api.patch(
          `/answer-categories/${this.myAnswer._id}`,
          {
            operation: 'add',
            categoryId: option._id,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      }
    },

    async handleSubCategoryClick(subCategory) {
      let operation = null;

      const categoryIndex = this.options.findIndex(
        (el) => el._id === this.mainCategoryId,
      );

      const category = this.options[categoryIndex];

      const subCategoryIndex = category.subCategories.findIndex(
        (el) => el._id === subCategory.subCategoryId,
      );

      if (subCategoryIndex >= 0) {
        operation = 'delete';
      } else {
        operation = 'add';
      }

      if (subCategoryIndex >= 0) {
        const index = this.myAnswer.subCategories.findIndex(
          (el) => el._id === subCategory._id,
        );

        if (index >= 0) {
          this.myAnswer.subCategories.splice(index, 1);
        }
      } else {
        this.myAnswer.subCategories.push(subCategory);
      }

      await api.patch(
        `/category-subcategory/${this.myAnswer._id}`,
        {
          subCategoryId: subCategory._id,
          categoryId: category._id,
          operation,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async showSubCategories() {
      this.loading = true;

      const response = await api.get(`/subcategories/${this.mainCategoryId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.subCategories = response.data;

      this.loading = false;
    },

    async getActionCategories() {
      if (this.categoryGroupId) {
        try {
          const response = await api.get('/categories-dropdown', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              categoryGroup: this.categoryGroupId,
            },
          });

          this.actionCategories = response.data;
          this.options = this.actionCategories;

          this.options.forEach((element) => {
            element.displaySubCategories = false;
            element.subCategories = [];
            element.loading = false;
          });
        } catch (error) {
          window.console.log(error);
        }
      }
    },
  },

  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getActionCategories();
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (this.mainCategoryId) {
      this.showSubCategories();
    }
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu li {
  width: 380px !important;
  margin-bottom: 10px;
}

.b-dropdown-text {
  padding: 8px !important;
}

.icon-eraser-category {
  margin-left: -5px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 5px;
}

.input-search-categories {
  width: 70%;
  margin-top: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 20px;
}

ul div {
  max-height: 250px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/add-treatment-categories/index.vue